import { render, staticRenderFns } from "./ImageDetail.vue?vue&type=template&id=18401676&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"
import style0 from "./ImageDetail.vue?vue&type=style&index=0&id=18401676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18401676",
  null
  
)

export default component.exports